////////LIBRARY/////////
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { map, find, isEmpty, isNull } from 'lodash'
import styled from 'styled-components'
import { shallowEqual, useSelector } from 'react-redux'

/////////STYLED/////////
const PaperListWrapper = styled.div`
	display: grid;
	grid-template-columns: min-content max-content max-content;
	grid-column-gap: 10px;
	justify-content: start;
	align-items: center;
	cursor: pointer;
`
const PaperListItems = styled.label`
	cursor: pointer;
`
const PaperCheckbox = styled.input`
	cursor: pointer;
`
const PaperPic = styled.img`
	width: 16px;
	height: 16px;
`
/////////STYLED/////////

/**
 *
 * @param data
 * @param translations
 * @param toTranslate
 * @param checkBoxHandler
 * @param target
 * @param radio
 * @return {JSX.Element}
 * @constructor
 */
const PaperList = ({ data, toTranslate, checkBoxHandler, target, radio, pics = [], showPaper }) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const oneIsUncheck = !find(data, { active: false })
	const [checkAll, setCheckAll] = useState({ id: 'checkAll', label: 'common__text__filter_all', active: oneIsUncheck })

	/////////////////////// HANDLE ///////////////////////////////////////

	const handleCheckAll = () => {
		checkBoxHandler(checkAll.id, checkAll.active, target, radio)
		setCheckAll((prevState) => ({
			...prevState,
			active: !prevState.active,
		}))
	}

	const handleUncheckCheckAll = (check) => {
		if (check) {
			setCheckAll((prevState) => ({
				...prevState,
				active: false,
			}))
		}
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			{data.length > 4 && !radio && (
				<PaperListWrapper onClick={handleCheckAll}>
					<PaperCheckbox
						checkedDefault={oneIsUncheck}
						id={checkAll.id}
						value={checkAll.label}
						checked={checkAll.active}
						type={!radio ? 'checkbox' : 'radio'}
						/* onChange={() => { }} */
					/>
					<PaperListItems>{translations[checkAll.label]}</PaperListItems>
				</PaperListWrapper>
			)}
			{map(data, (elem, id) => (
				<PaperListWrapper
					key={id}
					onClick={() => {
						handleUncheckCheckAll(elem.active)
						checkBoxHandler(elem.id, elem.active, target, radio)
					}}
				>
					<PaperCheckbox
						id={elem.id}
						value={elem.label}
						name={target}
						checked={elem.active}
						type={!radio ? 'checkbox' : 'radio'}
						/* onChange={() => {}} */
					/>
					{!isEmpty(pics) && pics[id].id === elem.id && <PaperPic src={`${pics[id].picture}`} />}
					{!isNull(elem.label) && elem.label.includes('/') ? (
						<PaperListItems>{elem.label.split(' / ')[0] + '/' + translations[elem.label.split(' / ')[1]]} </PaperListItems>
					) : (
						<PaperListItems>{toTranslate ? translations[elem.label] : elem.label} </PaperListItems>
					)}
				</PaperListWrapper>
			))}
		</>
	)
}

PaperList.propTypes = {
	data: PropTypes.array,
	translations: PropTypes.object,
	toTranslate: PropTypes.bool,
	checkBoxHandler: PropTypes.func,
	target: PropTypes.string,
	radio: PropTypes.bool,
}

PaperList.defaultPropTypes = {
	data: [],
	translations: {},
	toTranslate: false,
	// Default prop type => empty function
	checkBoxHandler: () => {},
	target: '',
	radio: false,
}

export default PaperList
